import AjaxForm from '@naturehouse/design-system/components/organisms/form/AjaxForm';
import HttpClient from '@naturehouse/design-system/js/utils/HttpClient';
import parseStringAsHtml from '@naturehouse/nh-essentials/lib/html/parser';
import GTM from '../../../gtm/GTM';
import GTMSignUpModel from '../../../gtm/models/GTMSignUpModel';

type LandlordRegistrationFormResponse = Response & AjaxResponse;
type LandlordRegistrationErrorResponse = Error & AjaxResponse;

class LandlordRegistrationForm extends AjaxForm {
    readonly #submitButton: HTMLButtonElement | null = null;

    constructor() {
        super();

        this.#submitButton = this.querySelector('button[type="submit"]');
    }

    public async submitForm(event?: Event): Promise<boolean> {
        event?.preventDefault();

        const url = this.getAttribute('action') ?? window.location.href;
        const formData = new FormData(this);
        const data = HttpClient.convertFormDataToQueryString(formData);

        if (this.#submitButton) {
            this.#submitButton.disabled = true;
        }

        try {
            const response = await HttpClient.post(url, data);
            this.onSuccess(response as LandlordRegistrationFormResponse);
            return true;
        } catch (error: any) {
            this.onError(error as LandlordRegistrationErrorResponse);
            return false;
        }
    }

    protected onSuccess(response: LandlordRegistrationFormResponse): void {
        if (!response.data) {
            return;
        }

        GTM.track(GTMSignUpModel.parseToGTMData());

        window.location.href = response.data.url;
    }

    protected onError(response: LandlordRegistrationErrorResponse): void {
        if (!response.message) {
            return;
        }

        this.replaceWith(parseStringAsHtml(response.message, 'form'));
        document.dispatchEvent(new Event('rerender-captcha'));
    }
}

if (!customElements.get('landlord-registration-form')) {
    customElements.define('landlord-registration-form', LandlordRegistrationForm, {
        extends: 'form'
    });
}
